import { useState } from 'react';
import { Buttons, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import * as Styled from './styles';

const WatchClabeBanner = (): JSX.Element | null => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const [showClabe, setShowClabe] = useState(false);
  const { isLoading, data } = useFetchGetUserClabe();

  const showConfirmClabeBanner = !isLoading && data?.CLABE;
  return showConfirmClabeBanner ? (
    <Styled.ClabeContainer fullWidth align="center" justify="space-between">
      <Text type="paragraphs" size="S_L_S" color="dark">
        {showClabe
          ? t('ClabeInfo.provider.show', { clabe: data?.CLABE })
          : t('ClabeInfo.provider', { clabe: data?.CLABE?.slice(-4) })}
      </Text>
      <Buttons.Icon
        size="xxs"
        icon={showClabe ? 'IconShowPassword' : 'IconHidePassword'}
        mode="secondary"
        onClick={() => setShowClabe(!showClabe)}
      />
    </Styled.ClabeContainer>
  ) : null;
};

export default WatchClabeBanner;
